import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MaskedLine, FadeUp, Stagger, StaggerItem, SmartImage } from "@/components/motion-primitives";
import { BLOGS } from "@/data/content";

export default function Blog() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid="blog-page">
      <section className="relative overflow-hidden bg-navy pb-24 pt-40 text-white">
        <div className="noise-overlay absolute inset-0" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-6">
          <MaskedLine delay={0.9}>
            <span className="font-accent text-xs font-semibold uppercase tracking-[0.3em] text-gold">Our Blog</span>
          </MaskedLine>
          <h1 className="mt-6 max-w-3xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl">
            <MaskedLine delay={1.0}>Read before</MaskedLine>
            <MaskedLine delay={1.12}><span className="italic text-gold">you apply.</span></MaskedLine>
          </h1>
          <MaskedLine delay={1.3}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-slate-300">
              Honest, practical guides written by counselors who process real applications every week.
            </p>
          </MaskedLine>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-24 md:py-32">
        <Stagger className="grid grid-cols-1 gap-10 md:grid-cols-2">
          {BLOGS.map((b, i) => (
            <StaggerItem key={b.slug}>
              <Link
                to={`/blog/${b.slug}`}
                data-testid={`blog-list-card-${i}`}
                className="group block overflow-hidden rounded-xl border border-line bg-white shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lift"
              >
                <SmartImage src={b.img} alt={b.title} className="h-64 w-full" />
                <div className="p-8 md:p-10">
                  <p className="font-accent text-xs font-semibold uppercase tracking-widest text-gold">{b.date}</p>
                  <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-navy transition-colors duration-300 group-hover:text-gold">
                    {b.title}
                  </h2>
                  <p className="mt-4 text-base leading-relaxed text-muted">{b.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-accent text-xs font-bold uppercase tracking-widest text-navy">
                    Read the full article <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </motion.div>
  );
}
